export default class PasswordHelper {
    static isValid(password: string, confirmationPassword: string, onError: (s: string) => void): boolean {
        if (password !== confirmationPassword) {
            onError("Password and confirmation password must match.")
            return false
        }
        if (password.length < 8) {
            onError("Password must be at least 8 characters.")
            return false
        }
        return true
    }
}